module.exports = __webpack_public_path__ + "media/images/emails/existing_org_new_user_message/open-nicklpass-5d3718f04ae6301f054a2f126f1c5ab0.png";